export enum DimensionUnit {
  MILLIMETER = 'mm',
  INCH = 'inch',
}
